import {computed, ComputedRef} from "vue"
import store from "@/vue/planning/store/store"
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"

interface Package {
    codePackage: string;
    packageId?: string;
    name?: string;
    maxPromo?: number;
}

const availableNonTransportPackageCodes: ComputedRef<Array<Package>> = computed(() => {
    const allCodes = availableTransportPackCodes.value.map((_: any) => _.codePackage);
    const availableNonTransportPackageCodes = store.getters.availablePackCodes.filter((packCodeObj: any) => {
        if (allCodes.includes(packCodeObj.codePackage)) return false;
        return true;
    });
    return availableNonTransportPackageCodes;
})

export default availableNonTransportPackageCodes